export default __webpack_public_path__ + "static/media/car-battery-solid.2951fc70.svg";